import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { useMarketplaceClient } from "./useMarketplaceClient";
import { getProductsForAnAccount } from "../generated-api/marketplace";

export const useProductAssignments = (
  accountId?: string,
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useMarketplaceClient();

  const response = useQuery({
    queryKey: [QueryKeysEnum.ProductsForAccount, accountId],
    queryFn: async () => {
      const { data } = await getProductsForAnAccount({
        client,
        throwOnError: true,
        path: { accountId: accountId ?? "" },
      });

      return data.model;
    },
    enabled: Boolean(accountId),
    throwOnError,
  });

  return response;
};
